import React, {Component} from 'react';
import {Redirect, withRouter} from "react-router-dom";
import {Button, Form, Input, notification} from 'antd';
import {DefaultLayout} from "../../layouts";
import {Container} from "../../components";
import {Authentication, ShowErrorNotification} from '../../utils';
import QueryString from 'query-string';

class LoginPage extends Component {

    state = {
        loggingIn: false,
        loggedIn: false
    };

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.renderLoginForm = this.renderLoginForm.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                return ShowErrorNotification(
                    'Incorrect username or password',
                    'Please check your credentials and try again.'
                );
            }
            const {username, password} = values;
            this.setState({loggingIn: true});
            Authentication.login(username, password)
                .then(user => {
                    console.log("User logged in.", user);
                    notification.success({
                        message: "User logged in"
                    });
                    const {history, location} = this.props;
                    const {returnUrl} = QueryString.parse(location.search);
                    setTimeout(() => {
                        if (returnUrl !== undefined) {
                            console.log("Returning to url.", returnUrl);
                            history.push(returnUrl);
                        } else {
                            history.push("/");
                        }
                    }, 100);
                })
                .catch(err => {
                    if (err.code === 'UserNotConfirmedException') {
                        ShowErrorNotification('User not confirmed', err);
                    } else if (err.code === 'PasswordResetRequiredException') {
                        ShowErrorNotification('New password required', err);
                    } else if (err.code === 'NotAuthorizedException' || err.code === 'UserNotFoundException') {
                        ShowErrorNotification('Incorrect username or password', err);
                    } else {
                        ShowErrorNotification('An unexpected error occurred', err);
                    }
                })
                .finally(() => this.setState({loggingIn: false}));
        });
    }

    renderLoginForm() {
        const {getFieldDecorator} = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit} className="login-form">
                <Form.Item label='Username'>
                    {getFieldDecorator('username', {
                        rules: [
                            { required: true, message: 'Username is required' }
                        ],
                    })(<Input/>)}
                </Form.Item>
                <Form.Item label='Password'>
                    {getFieldDecorator('password', {
                        rules: [{ required: true, message: 'Password is required' }],
                    })(<Input.Password/>)}
                </Form.Item>
                <br/>
                <Button
                    type="primary"
                    htmlType="submit"
                    icon="login"
                    className="login-form-button"
                    loading={this.state.loggingIn}
                >
                    Login
                </Button>
            </Form>
        );
    }

    componentDidMount() {
        Authentication.getCurrentSession()
            .then(user => {
                if (user) this.setState({loggedIn: true});
            });
    }

    render() {
        if (this.state.loggedIn) {
            return <Redirect to="/"/>
        }
        return (
            <DefaultLayout>
                <Container size="small">
                    <div className="page">
                        <h1 className="page-header">Login</h1>
                        {this.renderLoginForm()}
                    </div>
                </Container>
            </DefaultLayout>
        );
    }
}

export default Form.create()(withRouter(LoginPage));
